import { FC, useContext, useEffect, useState } from "react";

import ShowPatientInformation from "../addCase/showPatientInformation";
import ShowPatientAddress from "../addCase/showPatientAddress";
import ShowPrescriberInformation from "../addCase/showPrescriberInformation";
import ShowInsuranceInformation from "../addCase/showInsuranceInformation";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
// import { AuthContext } from "src/context/authContext";
import { ToastTypes } from "src/types";

import { CaseStepThreeProps } from "./types";
import SignatureModal from "../modals/signatureModals/addSignatureModal";
import AddSignatureButton from "../addSignatureButton";
import ShowDiureticsInformation from "../addCase/showDiureticsInformation";
import { Controller } from "react-hook-form";
import ShowPatientTreatment from "../addCase/showPatientTreatment";




const CaseStepThree: FC<CaseStepThreeProps> = ({ getValues, selectedDoctorObj, control }): JSX.Element => {
    const { insurances_attributes } = getValues();
    const [isSignatureModalVisible, setIsSignatureModalVisible] = useState(false);
    const [userSignature, setUserSignature] = useState<string | null>(null);
    const [overrideSignature, setOverrideSignature] = useState<string | null>(null);
    const { showToast } = useContext(ToastContext);
    const { setLoader, hideLoader } = useContext(LoaderContext);
    //   const { userData } = useContext(AuthContext);
    //   const [signatureFile, setSignatureFile] = useState<File | null>(null);



    const { data: signatureUploadResponse, error: signatureUploadError, mutate: uploadSignatureMutate, removeErrorAndData: clearSignatureState,
    } = useFetch<any>(APIEndpoints.UPDATE_SIGNATURE, {}, { id: selectedDoctorObj?.id });
    const handleSignatureSave = async (signatureFile: File) => {
        if (signatureUploadResponse || signatureUploadError)
            clearSignatureState();

        const previewUrl = URL.createObjectURL(signatureFile);
        setUserSignature(previewUrl); // still keep userSignature for consistency
        setOverrideSignature(null); // clear old override first if needed
        setOverrideSignature(previewUrl);


        // setSignatureFile(signatureFile);
        setLoader();

        const formData = new FormData();
        formData.append("global_doctor[signature_data]", signatureFile);

        uploadSignatureMutate(formData);
    };

    useEffect(() => {

        if (signatureUploadResponse || signatureUploadError) {
            hideLoader();

            if (signatureUploadResponse?.status?.code === 200) {
                showToast(["Signature uploaded successfully"], ToastTypes.SUCCESS);
            } else if (signatureUploadError) {
                showToast(["Failed to upload signature"], ToastTypes.ERROR);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signatureUploadResponse, signatureUploadError]);
    return (
        <div className="">
            <ShowPatientInformation getValues={getValues} />
            
            <ShowPatientTreatment  getValues={getValues} />

            <ShowPatientAddress getValues={getValues} />

            <ShowPrescriberInformation getValues={getValues} />

            <ShowDiureticsInformation getValues={getValues} />

            {insurances_attributes ? insurances_attributes.map((item, index) => (
                <ShowInsuranceInformation key={index} id={index + 1} insurance={item} />
            )) : null}

            {/* <p className="alert alert-light" role="alert">
                mannkindCares assists health care professionals in the
                determination of whether treatment could be covered by the
                applicable third-party payer based on coverage guidelines provided
                by the payer and patient information provided by the health care
                provider. Third-party reimbursement is affected by many factors.
                Therefore, mannkindCares makes no representation or guarantee
                that full or partial insurance reimbursement or any other payment
                will be available.
            </p> */}


            <p className="alert alert-warning rounded-1" role="alert">
                <Controller
                    name="prescription_attributes.patient_consent"
                    control={control}
                    render={({ field }) => (
                        <>
                            <input className="me-2"
                                   type="checkbox"
                                   checked={field.value === true}
                                   onChange={(e) => field.onChange(e.target.checked)}
                            />
                            <span>
                                As the undersigned Prescriber, I hereby authorize and attest to the permission provided to me by the patient for the use or disclosure of the patient’s health information contained in this form to other healthcare providers and relevant and
                                necessary third-parties (including but not limited to (Mannkind Cares and their respective agents and contractors and other designees in furtherance of the patient’s treatment (“Providers”), and to health plans or insurers and their respective
                                agents and designees (“Insurers”) to: (1) determine the patient’s insurance benefits; (2) to secure any required prior authorizations; (3) transmit the necessary information to a pharmacy that will fill the patient’s prescription, and to obtain
                                information from the pharmacy regarding delivery of such prescribed medication and related matters; (4) contact the patient to obtain any necessary signatures, consents and information relating to the patient’s treatment; (5) contact the
                                patient regarding patient affordability programs, and to request information from the patient or from patient’s designees needed to determine eligibility for the program; (6) to coordinate care under the Mannkind Patient Navigator Program
                                and; (7) to provide other related care coordination services and (8) I agree to the Business Associate Agreement as presented in presented in the Resources Tab in this portal.
                            </span>
                        </>
                    )}
                />
                
                {/* <a
          href="https://furoscixdirect.com/users/sign_in" target="_blank"
          className="alert-link" rel="noreferrer"
        >
          www.furoscixdirect.com
        </a> */}
            </p>
            {/* { selectedDoctorObj && !selectedDoctorObj.signature &&
            <>
            <AddSignatureButton
                userSignature={
                    overrideSignature
                        ? overrideSignature
                        : selectedDoctorObj?.signature
                            ? selectedDoctorObj.signature
                            : userSignature ?? null
                }
                addCase={!overrideSignature && !!selectedDoctorObj?.signature}
                onClick={() => setIsSignatureModalVisible(true)}
                addCaseFlow={true}
            />
                <SignatureModal
                isOpen={isSignatureModalVisible}
            onClose={() => setIsSignatureModalVisible(false)}
            onSave={(file) => {
                if (selectedDoctorObj?.id) {
                    handleSignatureSave(file);
                } else {
                    showToast(["Please select a prescriber before adding a signature."], ToastTypes.ERROR);
                    setIsSignatureModalVisible(false); // optionally close modal
                }
            }}
        />
        </>
} */}
        </div>
    );
};

export default CaseStepThree;
